import core, { App } from '@gin-betting/core';

import { SidebarView } from 'app-constants';
import { FavoriteCountType } from './types';
import {
    CHANGE_ODD_FORMAT,
    CHANGE_SIDEBAR_VIEW,
    CHANGE_FAVORITE_COUNT,
    CHANGE_ODDS_STATISTIC,
    ENABLE_ODD_HISTORY,
    DISABLE_ODD_HISTORY,
    OPEN_SIDEBAR,
    CLOSE_SIDEBAR,
    OPEN_MOBILE_TOP_MATCHES,
    CLOSE_MOBILE_TOP_MATCHES,
    OPEN_FILTER,
    CLOSE_FILTER,
    SET_ACTIVE_SPORT_TYPE,
} from './constants';

const { makeAction } = core.utils;

export function changeOddFormat(payload: { oddFormat: App.OddFormat }) {
    return makeAction(CHANGE_ODD_FORMAT, payload);
}

export function changeFavoriteCount(payload: {
    count: number;
    type: FavoriteCountType;
}) {
    return makeAction(CHANGE_FAVORITE_COUNT, payload);
}

export function changeSidebarView(payload: { sidebarView: SidebarView }) {
    return makeAction(CHANGE_SIDEBAR_VIEW, payload);
}

export const enableOddHistory = () => makeAction(ENABLE_ODD_HISTORY);
export const disableOddHistory = () => makeAction(DISABLE_ODD_HISTORY);
export const toggleOddHistory = ({ isEnable }: { isEnable: boolean }) =>
    isEnable ? disableOddHistory() : enableOddHistory();

export const openSidebar = () => makeAction(OPEN_SIDEBAR);
export const closeSidebar = () => makeAction(CLOSE_SIDEBAR);
export const toggleSidebar = ({ isOpen }: { isOpen: boolean }) =>
    isOpen ? openSidebar() : closeSidebar();

export function changeOddsStatisticView(payload: {
    statisticView?: App.OddStatisticView;
    show?: boolean;
}) {
    return makeAction(CHANGE_ODDS_STATISTIC, payload);
}

export const openMobileTopMatches = () => makeAction(OPEN_MOBILE_TOP_MATCHES);
export const closeMobileTopMatches = () => makeAction(CLOSE_MOBILE_TOP_MATCHES);

export const openFilter = () => makeAction(OPEN_FILTER);
export const closeFilter = () => makeAction(CLOSE_FILTER);

export const setActiveSportType = (nextSportType: App.SportType) =>
    makeAction(SET_ACTIVE_SPORT_TYPE, nextSportType);

export const Actions = {
    changeOddFormat,
    toggleOddHistory,
    changeSidebarView,
    changeFavoriteCount,
    changeOddsStatisticView,
    openSidebar,
    closeSidebar,
    toggleSidebar,
    openMobileTopMatches,
    closeMobileTopMatches,
    openFilter,
    closeFilter,
    setActiveSportType,
};

/* eslint-disable no-redeclare */
export type Actions = App.ActionsUnion<typeof Actions>;
